module.exports = __webpack_public_path__ + "static/img/ch-on-echo.c17b5b72.png";